document.addEventListener("DOMContentLoaded", function () {
    const cartContainer = document.querySelector(".yv_cart-poroduct-container");
    const similarDrawerBody = document.querySelector(".yv_similar_drawer_body");
    const widgetSelector = ".indexesm__Container-u07xae-14"; // Sélecteur du widget à surveiller

    function adjustHeight() {
        const widget = document.querySelector(widgetSelector);

        // Vérifiez si le widget est présent dans le DOM
        const hasWidget = widget && widget.offsetParent !== null;

        if (cartContainer) {
            if (hasWidget) {
                cartContainer.classList.remove("has-no-widget");
            } else {
                cartContainer.classList.add("has-no-widget");
            }
        }

        if (similarDrawerBody) {
            if (hasWidget) {
                similarDrawerBody.classList.remove("has-no-widget");
            } else {
                similarDrawerBody.classList.add("has-no-widget");
            }
        }
    }

    // Exécutez la fonction au chargement initial
    adjustHeight();

    // Surveillez les modifications du DOM pour détecter l'ajout ou le retrait du widget
    const observer = new MutationObserver(adjustHeight);

    observer.observe(document.body, {
        childList: true,
        subtree: true,
    });

    // Nettoyez l'observateur lorsque la page est déchargée
    window.addEventListener("beforeunload", function () {
        observer.disconnect();
    });
});
